import { render, staticRenderFns } from "./LicenceSettingEditor.vue?vue&type=template&id=44f1c793"
import script from "./LicenceSettingEditor.vue?vue&type=script&lang=js"
export * from "./LicenceSettingEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports